import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class ProgressTrackerService {

    public onStepChanged: EventEmitter<any> = new EventEmitter<any>();

    private _step:number = 0;
    public get step(): number {
        return this._step;
    } public set step(value: number) {
        this._step = value;
        this.onStepChanged.emit();
    }
}
